import React, { useContext } from 'react'
import Box from '@mui/material/Box'
import Badge from '@mui/material/Badge'
import Tooltip from '@mui/material/Tooltip'
import { NavLink, useLocation } from 'react-router-dom'
import Stack from '@mui/material/Stack'

import { SiteModeContext } from '../MainFrame'
import { GlobalContext, UserContext } from '../../../App'
import LockIcon from '@mui/icons-material/Lock'

const SidebarNavItem = ({
  icon,
  title,
  url = '/',
  end,
  // sub-paths of this item's url that belong to other sidebar items —
  // suppresses the NavLink prefix match so only the sibling highlights
  exclude,
  // the mirror of `exclude`: extra path prefixes that belong to this item
  // even though they don't share its url (e.g. a module whose tabs live on
  // sibling routes), so the item stays highlighted across them
  alsoMatch,
  requiredTier,
  suppressActiveStyle,
  // count of things needing attention on this page (from /nav-counts)
  badge,
}) => {
  const { pathname } = useLocation()
  const excluded = exclude?.some((prefix) => pathname.startsWith(prefix))
  const alsoMatched = alsoMatch?.some((prefix) => pathname.startsWith(prefix))
  const SBStateContext = useContext(SiteModeContext)
  const { collapsed } = SBStateContext.sidebarState
  const { tenantInfo } = useContext(GlobalContext)
  const { user } = useContext(UserContext)
  const shouldSeeUpgrade =
    user?.security?.isSiteAdmin ||
    [
      'Event Planning',
      'Commerical Training',
      'Governance',
      'Manager',
      'Supervisor',
      'Personnel',
      'Make Ready',
      'Fleet',
      'Finance',
    ].some((team) => user?.employee?.teams?.includes(team))

  const badgeCount = Number(badge) > 0 ? Number(badge) : 0
  const upgradeRequired = requiredTier
    ? Number(requiredTier) > Number(tenantInfo?.subscriptionTier)
    : false

  if (upgradeRequired && !shouldSeeUpgrade) return null

  return (
    <NavLink
      to={url}
      className={({ isActive }) =>
        (isActive || alsoMatched) && !excluded && !suppressActiveStyle
          ? 'sidebar_navitem active'
          : 'sidebar_navitem'
      }
      end={end}
      // onClick={(e) => {
      //   if (upgradeRequired) {
      //     e.preventDefault()
      //     setUpgradeRequired({
      //       requiredTier,
      //       currentTier: Number(tenantInfo?.subscriptionTier || 1),
      //     })
      //   }
      // }}
    >
      {collapsed ? (
        <Tooltip
          title={badgeCount ? `${title} (${badgeCount})` : title}
          placement="right"
        >
          <Box margin={1} display="flex" justifyContent="center" flex={1}>
            <Badge
              badgeContent={badgeCount || null}
              color="error"
              sx={{ '& .MuiBadge-badge': { fontSize: 10, height: 15, minWidth: 15 } }}
            >
              {icon}
            </Badge>
          </Box>
        </Tooltip>
      ) : (
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          width="100%"
          paddingY={0.5}
          paddingX={1}
        >
          <Stack
            direction="row"
            flex={1}
            // paddingX={2}
            // paddingY={1}
            spacing={1}
            sx={{ alignItems: 'center' }}
          >
            {icon}
            {!collapsed && <Box fontSize={14}>{title}</Box>}
          </Stack>
          {upgradeRequired ? (
            <Tooltip title="Upgrade Required">
              <LockIcon sx={{ fontSize: 18, color: '#8FA3B8' }} />
            </Tooltip>
          ) : (
            badgeCount > 0 && (
              <Box
                sx={{
                  fontSize: 11,
                  fontWeight: 700,
                  lineHeight: 1,
                  px: 0.75,
                  py: 0.5,
                  mr: 0.5,
                  borderRadius: '999px',
                  backgroundColor: 'rgba(44, 177, 188, 0.9)',
                  color: '#0B1520',
                  flexShrink: 0,
                }}
              >
                {badgeCount > 99 ? '99+' : badgeCount}
              </Box>
            )
          )}
        </Stack>
      )}
    </NavLink>
  )
}

export default SidebarNavItem
